import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

const BASE = `${DATA_SERVICE_BASE_URL}/api/admin/reminder-policies`;

/**
 * Admin API for reminder policies (lead-time defaults, daily cap, digest hour).
 * Each call returns the parsed JSON body or throws on a non-OK response.
 */
export const ReminderPolicyApi = {
  /** List all reminder policy rows. */
  list: async () => {
    const resp = await fetchWithAuth(BASE, { method: 'GET' });
    if (!resp.ok) throw new Error(`Failed to load reminder policies (${resp.status})`);
    return resp.json();
  },

  /**
   * Update a single policy by category.
   * @param {string} category
   * @param {{ leadMinutesCsv: string, enabled: boolean, description: string }} body
   */
  update: async (category, body) => {
    const resp = await fetchWithAuth(`${BASE}/${encodeURIComponent(category)}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!resp.ok) throw new Error(`Failed to update policy "${category}" (${resp.status})`);
    return resp.json();
  },

  /** Reset all policies to their seeded defaults. */
  reset: async () => {
    const resp = await fetchWithAuth(`${BASE}/reset`, { method: 'POST' });
    if (!resp.ok) throw new Error(`Failed to reset reminder policies (${resp.status})`);
    return resp.json();
  },
};

export default ReminderPolicyApi;
